<template>
  <form style="position: relative">
    <div style="position: absolute; top: 10px; right: 10px;">
      <CopyBlock :sharedData="sharedData" />
    </div>
    <h2>Text Block</h2>
    <!-- Abschnitt "Main" -->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('main')">
        <span>{{ $t('Add.Text.Editor') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('main') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('main')" class="accordion-content">
        <div class="divider">
          <label class="contentLabel" for="textContent">{{ $t('Add.Text.Content') }}</label>
          <div class="editor">
            <!-- Toolbar -->
            <div class="toolbar">
              <button type="button" @click="emitUndo">
                <span class="material-symbols-outlined">undo</span>
              </button>
              <button type="button" @click="emitRedo">
                <span class="material-symbols-outlined">redo</span>
              </button>
              <button type="button" @click="emitToggleBold"><b>B</b></button>
              <button type="button" @click="emitToggleItalic"><i>I</i></button>
              <button type="button" @click="emitToggleUnderline"><u>U</u></button>
              <button type="button" @click="emitToggleStrike"><s>S</s></button>
              <button type="button" @click="emitMarkPlaceholder">
                <span class="material-symbols-outlined toolbarIcon">bolt</span>
              </button>
              <button type="button" @click="emitEnterRule">
                <span class="material-symbols-outlined toolbarIcon">rule</span>
              </button>
              <button type="button" @click="emitAddLink">
                <span class="material-symbols-outlined toolbarIcon">link</span>
              </button>
              <button type="button" @click="emitSubscript">
                <span class="material-symbols-outlined toolbarIcon">subscript</span>
              </button>
              <button type="button" @click="emitSuperscript">
                <span class="material-symbols-outlined toolbarIcon">superscript</span>
              </button>
               <!-- Neuer Button für den Word-Upload -->
              <button type="button" @click="triggerFileUpload">
                <img class="wordLogo" src="../../../public/msWordIcon.png">
              </button>
              <!-- Versteckter File Input -->
              <input type="file" ref="wordFileInput" accept=".doc,.docx" style="display: none" @change="handleFileUpload" />
            </div>
          <!-- Weitere Komponenten wie Modals etc. können hier folgen -->
          <FontSizeProp :sharedData = "sharedData"/>
          <FontFamilyProp :sharedData="sharedData"/>
          <div class="divider">
            <label class="contentLabel" for="textColor">Text Color</label>
            <div class="color-container">
              <input 
                type="color" id="textColor" name="textC"
                :value="color"  
                @input="emitColor($event.target.value)"
               />
              <span v-if="color" class="material-symbols-outlined reset-color" @click="emitResetColor">refresh</span>
              <div v-else class="add-color-overlay">+</div>
            </div>
          </div>
          <!-- <TextColorProp :sharedData="sharedData"/> -->
          <BackgroundColorProp :sharedData="sharedData"/>
        </div>
      </div>
      </div>
    </div>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('rule')">
        <span>{{ $t('Add.General.Rule') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('rule') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('rule')" class="accordion-content">
        <div v-if= sharedData.data.props.rules>
          <div class="conditions" v-for="(rule, index) in sharedData.data.props.rules" :key="index">
            <span><strong>Rule {{ index + 1 }}</strong></span>
            <button class="delete-button" type="button" @click="removeCondition(index)">
              <span class="material-symbols-outlined">delete</span>
            </button>
            <input
              type="text"
              id="replacedText"
              v-model="rule.replacedText"
              placeholder="old Text"
            />
            <select v-model="rule.statement">
              <option value="" disabled selected>XML-path placeholder</option>
              <option v-for="placeholder in placeholders" :key="placeholder" :value="placeholder">
                {{ placeholder }}
              </option>
            </select>
            <select v-model="rule.operator" class="operator-select">
              <option value="" disabled selected>Operator</option>
              <option value="=">=</option>
              <option value="!=">!=</option>
              <option value="<">&lt;</option>
              <option value=">">&gt;</option>
              <option value="else">{{ $t('Add.Ruleset.else') }}</option>
            </select>
            <input
              type="text"
              id="valueName"
              v-model="rule.value"
              placeholder="condition value"
            />
            <input
              type="text"
              id="textName"
              v-model="rule.text"
              placeholder="new text"
            />
          </div>
        </div>
        <div v-else>
          Keine Textregeln angelegt
        </div>
        <div class="divider">
        <button type="button" class="addRuleButton" @click="addTextRule">
          <span class="material-symbols-outlined">add</span> {{ $t('Add.Ruleset.AddCondition') }}
        </button>
      </div>
      </div>
    </div>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('style')">
        <span>{{ $t('Add.General.Main') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('style') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
    <div v-show="isSectionActive('style')" class="accordion-content">
      <NameProp :sharedData="sharedData" />
      <ClassNamesProp :sharedData="sharedData" />
    </div>
    </div>
    <!-- Reiter: Positioning -->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('positioning')">
        <span>{{ $t('Add.General.Positioning') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('positioning') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('positioning')" class="accordion-content">
        <AlignmentProp :sharedData="sharedData"/>
        <PaddingProp :sharedData="sharedData"/>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import NameProp from './AddProps/NameProp.vue'
import ClassNamesProp from './AddProps/ClassNamesProp.vue'
import TextProp from './AddProps/TextProp.vue';
//import TextColorProp from './AddProps/TextColorProp.vue';
import BackgroundColorProp from './AddProps/BackgroundColorProp.vue';
import AlignmentProp from './AddProps/AlignmentProp.vue';
import FontFamilyProp from './AddProps/FontFamilyProp.vue';
import FontSizeProp from './AddProps/FontSizeProp.vue';
import PaddingProp from './AddProps/PaddingProp.vue';
import CopyBlock from './AddProps/CopyBlock.vue'
import eventBus from '@/eventBus.js'
import mammoth from 'mammoth'

export default {
  name: 'AddText',
  components: {
    NameProp,
    ClassNamesProp,
    CopyBlock,
    TextProp,
    BackgroundColorProp,
    AlignmentProp,
    FontFamilyProp,
    FontSizeProp,
    PaddingProp
  },
  props: ['sharedData'],
  data() {
    return {
      openModal: false,
      isUniqueName: true,
      selectedText: '',
      openXmlModal: false,
      openConditionalText: false,
      color: null
    }
  },
  computed: {
    ...mapState(['emailData', 'xPathPlaceholders']),
    placeholders() {
      return this.xPathPlaceholders.map(item => item.placeholder)
    },
    activeSections: {
      get() {
        return this.sharedData?.data?.props?.activeSections || ['main']
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {}
        this.sharedData.data.props.activeSections = value
      }
    },
    textColor: {
      get() {
        return this.sharedData?.data?.style?.color || '';
      },
      set(value) {
        if (!this.sharedData.data.style) {
          this.sharedData.data.style = {};
        }
        this.sharedData.data.style.color = value;
      },
    },
    editorStyle() {
      return {
        minHeight: '100px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '5px',
        fontSize: '14px'
      }
    }
  },
  methods: {
    toggleSection(section) {
      if (this.activeSections.includes(section)) {
        this.activeSections = this.activeSections.filter(s => s !== section)
      } else {
        this.activeSections.push(section)
      }
    },
    isSectionActive(section) {
      return this.activeSections.includes(section)
    },
    addTextRule(){
    if (!this.sharedData.data.props) this.sharedData.data.props = {};
    this.sharedData.data.props.rules.push({replacedText:"", statement:"", operator: "", value: "", text: "" });
  },
  removeCondition(index) {
      this.sharedData.data.props.rules.splice(index, 1);
    },
    updateColor(payload) {
      console.log(payload.color)
        this.color = payload.color
    },
    // Event-Emitter für die Toolbar-Buttons – hier wird jeweils die sharedData.id (contentId) mitgegeben
    emitToggleBold() {
      eventBus.emit('toggleBold', { contentId: this.sharedData.id })
    },
    emitToggleItalic() {
      eventBus.emit('toggleItalic', { contentId: this.sharedData.id })
    },
    emitToggleUnderline() {
      eventBus.emit('toggleUnderline', { contentId: this.sharedData.id })
    },
    emitToggleStrike() {
      eventBus.emit('toggleStrike', { contentId: this.sharedData.id })
    },
    emitMarkPlaceholder() {
      eventBus.emit('markPlaceholder', { contentId: this.sharedData.id })
    },
    emitEnterRule() {
      eventBus.emit('enterRule', { contentId: this.sharedData.id })
    },
    emitAddLink() {
      eventBus.emit('addLink', { contentId: this.sharedData.id })
    },
    emitUndo() {
      eventBus.emit('undo', { contentId: this.sharedData.id })
    },
    emitRedo() {
      eventBus.emit('redo', { contentId: this.sharedData.id })
    },
    emitSuperscript() {
      eventBus.emit('superscript', { contentId: this.sharedData.id })
    },
    emitSubscript() {
      eventBus.emit('subscript', { contentId: this.sharedData.id })
    },
    emitColor(color) {
      this.color = color;
      eventBus.emit('toggleColor', { contentId: this.sharedData.id, colorCode: color })
    },
    emitResetColor(){
      this.color = null;
      eventBus.emit('resetColor', { contentId: this.sharedData.id})
    },
    triggerFileUpload() {
      this.$refs.wordFileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
          .then(result => {
            // Sende das konvertierte HTML an den Editor
            eventBus.emit('uploadDocx', { contentId: this.sharedData.id, html: result.value });
          })
          .catch(error => {
            console.error('Error converting document:', error);
          });
      };
      reader.readAsArrayBuffer(file);
      // Leere den Input, damit dieselbe Datei später erneut ausgewählt werden kann
      event.target.value = '';
    }
  },
  mounted() {
    eventBus.on('updateTextStyle', this.updateColor)
  },
  beforeUnmount() {
    eventBus.off('updateTextStyle', this.updateColor)
  },
}
</script>

<style scoped>
@import '../../styles/addComponents.css';

button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  width: 35px;
  font-size: 18px;
  background-color: transparent;
  color: black;
  border: 1px solid #ccc;
  transition: background-color 0.3s;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background: rgb(241, 238, 238);
}

.toolbarIcon {
  font-size: 20px;
}

.wordLogo{
  height: 20px;
  width: 20px;
}

.toolbar {
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding: 5px;
  max-width: 95%;
  margin-top: 10px;
  border-radius: 4px;
  border: 1px solid #cccc;
  margin-bottom: 30px;
}


button {
  padding: 5px 10px;
  cursor: pointer;
  background-color: transparent;
  border: none;
}

button:hover {
  background-color: #ddd;
}

.openModalButton:hover {
  background-color: transparent;
}

.openModalButton{
  padding: 0px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  text-align: right;
  margin-top: 10px;
  margin-bottom: 10px;
 }

 button:focus {
  outline: none;
}

.conditions {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 15px;
  padding: 10px;
  padding-top: 35px;
  margin-bottom: 5px;
}

.conditions input{
  width: 95%;
}

.delete-button, .toggle-button{
  padding: 5px;
  position: absolute;
  top: 5px;
  right: 5px;
  background: transparent;
  color: black;
  border: none;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  transition: opacity 0.3s;
  z-index: 10;
}

.delete-button:hover {
  background: transparent;
}

.delete-button {
  position: absolute;
  top: 5px;
  right: 5px;
}

.addRuleButton{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  font-size: 14px;
  background-color: transparent;
  color: black;
  border: 1px solid #ccc;
  transition: background-color 0.3s;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  width: 120px;
}

button:hover {
  background: rgb(241, 238, 238);
}
</style> 
